import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import StopIcon from "../../../../../../assets/images/icons/StopIcon";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton";
import { useAppStore } from "../../../../../../hooks/useStores";
import { isPlaygroundLoadingImages } from "../../../../../../utils";
import styles from "../TextToImageSearch.module.scss";

type Props = {
	handleGenerate?: () => Promise<void>;
	onError?: () => void;
	onStop?: () => void;
	className?: string;
	isTgEvaluation?: boolean;
};
const TextToImageGenerateButton = ({ handleGenerate, onError, onStop, className, isTgEvaluation }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.generator.searchBox" });
	const { textToImageStore, authStore, playgroundStore } = useAppStore();
	const hasLoadingImages = isPlaygroundLoadingImages(
		playgroundStore.playgroundResults,
		playgroundStore.selectedConfig,
	);
	const isGenerateEnabled =
		(textToImageStore.config.model || textToImageStore.config.tailored_model_id) &&
		(textToImageStore.config.prompt || textToImageStore.config.generation_prefix) &&
		!authStore.isLoadingOrgSubscriptions &&
		!authStore.orgPassedFreeLimit &&
		!authStore.isSubscriptionInactive &&
		!hasLoadingImages;

	const handleClick = async () => {
		try {
			if (handleGenerate) {
				await handleGenerate();
			} else {
				await textToImageStore.generateTextToImage(undefined, isTgEvaluation);
			}
		} catch (err: any) {
			onError?.();
		}
	};

	const handleAbort = () => {
		onStop?.();
		textToImageStore.abortImageGeneration();
	};

	return (
		<>
			{hasLoadingImages ? (
				<BriaButton
					buttonType="primaryMedium"
					className={clsx(className, styles.button, styles.stopGeneratingBtn)}
					onClick={handleAbort}
				>
					<StopIcon /> {t("stop")}
				</BriaButton>
			) : (
				<BriaButton
					buttonType="primaryMedium"
					className={`${className || ""} ${styles.button}`}
					onClick={handleClick}
					loading={authStore.isLoadingOrgSubscriptions}
					disabled={!isGenerateEnabled || textToImageStore.isUploadingImageReference}
				>
					{t("button")}
				</BriaButton>
			)}
		</>
	);
};

export default observer(TextToImageGenerateButton);
